import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import {BUILDING_TYPE} from '@buildium/angularjs-core/dist/constants/properties';
import moment from 'moment-timezone';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getActiveByUnit: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/:id/activeLeases`,
        isArray: true
    },
    getActiveByUnitIds: {
        method: 'GET',
        url: `${BASE_PATH_API}/activeUnitAgreements`,
        isArray: true
    },
    getActiveUnitAgreementsByProperty: {
        method: 'GET',
        url: `${BASE_PATH_API}/properties/:propertyId/activeUnitAgreements`,
        isArray: true
    },
    getLeasesByUnit: {
        method: 'GET',
        url: `${BASE_PATH_API}/units/:unitId/leases`,
        isArray: true
    },
    addApplicantToLease: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/applicants/:applicantId`
    },
    addNewLease: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases`
    },
    updateLease: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id`
    },
    updateLeaseV2: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/v2/:id`
    },
    turnOffMasterInsuranceForLease: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:id/masterInsurancePolicies/self`
    },
    activateMasterInsuranceForExistingLease: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/:id/masterInsurancePolicies/self`,
    },
    deleteLease: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:id`
    },
    updateNewLease: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/details`
    },
    updateLeaseComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/comment`
    },
    getTenants: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/residents`,
        isArray: true
    },
    getActiveTenants: {
        method: 'GET',
        url: `${BASE_PATH_API}/lease/:id/tenants/active`,
        isArray: true
    },
    getCosigners: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/cosigners`,
        isArray: true
    },
    getActiveCosigners: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/cosigners/active`,
        isArray: true
    },
    getRecurringCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/recurringCharges/lease/:id`,
        isArray: true
    },
    getRecurringTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/recurringTransactions`,
        isArray: true
    },
    getRecurringTransactionsByLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/recurringTransactionsByLeaseId`,
        params: {
            '$count': true
        }
    },
    deleteRecurringTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/recurringCharges/:id`
    },
    getNonRentRecurringTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/nonRentRecurringTransactions`,
        isArray: true
    },
    getDepositsHeld: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/depositsHeld`,
        isArray: true
    },
    getCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/charges/lease/:id`,
        isArray: true
    },
    getLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id`
    },
    getLeaseLedgerInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/ledger/leases/:id`
    },
    getLeaseResident: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/:residentId`
    },
    updateLeaseResident: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/:residentId`
    },
    getLeaseHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/history`,
        isArray: true
    },
    getLeaseBalanceSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/balanceSummary`
    },
    getLeaseDeletable: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/deletable`
    },
    getExistingTenantsAndApprovedApplicants: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/potentialTenants`,
        isArray: true
    },
    addCosignersToLease: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/:leaseId/cosigners`
    },
    getLeaseSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/settings`
    },
    getPendingPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/pendingPayments`,
        isArray: true
    },
    getRecurringPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/recurringPayments`,
        isArray: true
    },
    getRentDetails: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/rentDetails`,
    },
    getLeaseAftPaymentInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/leaseAftPaymentInfo`
    },
    getLeaseRenewalOffer: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:id/getRenewalOffer`
    },
    generateRenewalsMailings: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/generateRenewalsMailings?groupByLease=:groupByLease`
    },
    activateRenewal: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/renew/:renewalOfferId`
    },
    getLeasesOutstandingBalances: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/outstandingBalances`,
        isArray: true
    },
    submitPaymentsInBulk: {
        method: 'POST',
        url: `${BASE_PATH_API}/unitAgreements/bulk/payments?type=${BUILDING_TYPE.Rental}`,
        isArray: true
    },
    getLeaseResidents: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/residents`,
        isArray: true
    },
    getAllLeases: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases`,
        params: {
            '$count': true
        }
    },
    getRentRollExport: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/export`
    },
    getTenantsByLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/tenants`,
        isArray: true
    },
    moveOutTenants: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/residents`
    },
    bulkMoveOutTenants: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/bulk`
    },
    undoMoveOutTenant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/:id/undoMoveOut`
    },
    undoMoveInTenant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/:id/undoMoveIn`
    },
    moveInExistingTenant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/:id/moveIn`
    },
    moveInApprovedApplicant: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/applicants/:id`
    },
    moveInExistingApplicants: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/applicants/moveIn`
    },
    moveInNewTenant: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/:id/residents`
    },
    moveInApprovedApplicantsAndExistingTenantsBulk: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/residents/bulkMoveIn`
    },
    updatePaymentSettingsForLease: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentSettings`
    },
    deletePaymentSettingsForLease: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentSettings`
    },
    getPaymentReminderSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentReminders`
    },
    updatePaymentReminderSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentReminders`
    },
    deletePaymentReminderSettings: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentReminders`
    },
    getPrepaymentSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/prepaymentSettings`
    },
    getPaymentAllocationSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/paymentAllocationSettings`
    },
    getGlAccountBalancesByLease: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/balances`
    },
    renewLeaseByExtension: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/:leaseId/extend`
    },
    getCreditInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/credits/:journalId`
    },
    saveCredits: {
        method: 'POST',
        url: `${BASE_PATH_API}/credits`
    },
    updateCredit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/credits/:journalId`
    },
    deleteCredit: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/credits/:journalId`
    },
    getLeaseResidentsAll: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/residentsAll`
    },
    getLeaseGlAccountBalancesForRefund: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/balances/refund`
    },
    getRefundInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/refunds/:journalId`
    },
    saveRefunds: {
        method: 'POST',
        url: `${BASE_PATH_API}/refunds`
    },
    saveResidentRefunds: {
        method: 'POST',
        url: `${BASE_PATH_API}/v1/residentRefunds`
    },
    updateRefund: {
        method: 'PUT',
        url: `${BASE_PATH_API}/refunds/:journalId`
    },
    deleteRefund: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/refunds/:journalId`
    },
    saveApplyDeposit: {
        method: 'POST',
        url: `${BASE_PATH_API}/withhelddeposits`
    },
    getUnpaidLateFees: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/unpaidLateFees`
    },
    getLeasesForPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/list`
    },
    getAppliedDeposit: {
        method: 'GET',
        url: `${BASE_PATH_API}/withhelddeposits/:journalId`
    },
    updateAppliedDeposit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/withhelddeposits/:journalId`
    },
    deleteAppliedDeposit: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/withhelddeposits/:journalId`
    },
    getRenewalsHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/renewal-history`
    },
    getRenewalsHistoryV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/v2/leases/:leaseId/renewal-history`
    },
    getLeaseLedgerByDate: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/ledgerByDate`,
        params: {
            '$count': true
        }
    },
    getLeaseLedgerByAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/ledgerByAccount`,
        params: {
            '$count': true
        }
    },
    deleteLedgerTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/leases/:leaseId/ledger/:journalId`
    },
    resetLeaseBalance: {
        method: 'POST',
        url: `${BASE_PATH_API}/leases/:leaseId/resetBalance`,
    },
    getLeaseDeposits: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/deposits`,
        params: {
            '$count': true
        }
    },
    isResidentStatementEmailAllowed: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/isResidentStatementEmailAllowed`
    },
    updateMoveOutComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/updateMoveOutComment`
    },
    updateMoveOutStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/bulk/moveOutStatus/:status`
    },
    updateRenewalStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/bulk/renewalStatus/:status`
    },
    sendResidentStatement: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/SendResidentStatement`
    },
    getLeasingAgents: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/leasingAgents`
    },
    getLeaseFinancialsInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/financials`
    },
    getLeaseTenantsInformation: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/tenantsInfo`
    },
    getLeaseApplicant: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/applicant/:applicantId`
    },
    getLiabilityGlAccounts: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseLiabilities/glAccounts`
    },
    getLeasesLiabilities: {
        method: 'GET',
        url: `${BASE_PATH_API}/leaseLiabilities`,
        params: {
            '$count': true
        }
    },
    getExpiredLeasesWithLiabilitiesCount: {
        method: 'HEAD',
        url: `${BASE_PATH_API}/leaseLiabilities`,
        transformResponse: function transformResponse(response, headers) {
            return parseInt(headers.get('X-Total-Count'), 10);
        }
    },
    getExistingTenantsAndApprovedApplicantsByLeaseId: {
        method: 'GET',
        url: `${BASE_PATH_API}/leases/:leaseId/potentialTenants`,
        isArray: true
    },
    updateLeasingComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:id/leasingComment`
    },
    moveOutComment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/leases/:leaseId/moveOutComment`
    }
};

export function LeasesApi(
    RENEWALS_DATE_RANGE_UPPER_LIMIT,
    LeaseType,
    Settings,
    BdLocalize,
    $q,
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getLeasesExportUrl = function getLeasesExportUrl(params) {
        return `${BASE_PATH_API}/leases/export?${$httpParamSerializer(params)}`;
    };

    service.getLeaseStatementPrintURL = function getLeaseStatementPrintURL(leaseId) {
        return `${BASE_PATH_API}/leases/${leaseId}/printStatement`;
    };

    service.getToday = function getToday() {
        return moment.tz(Settings.SubscriberSettingsInfo.TzInfoName);
    };

    service.validateNextDate = function validateNextDate(leaseEndDate, nextChargeDate) {
        const endDate = new Date(leaseEndDate);
        if (moment(leaseEndDate).isBefore(nextChargeDate)) {
            return $q.reject(BdLocalize.getString(
                'Accounting.LeaseRecurringTransactions.SplitViewPanel.Text.ValidateNextDate',
                `This lease ends on ${endDate}. Please ensure the next date is before the end of the lease.`,
                [endDate]
            ));
        }
        return $q.when(true);
    };
    return service;
}

LeasesApi.$inject = [
    'RENEWALS_DATE_RANGE_UPPER_LIMIT',
    'LeaseType',
    'Settings',
    'BdLocalize',
    '$q',
    '$httpParamSerializer'
];
